module.exports = __webpack_public_path__ + "static/media/charity.49cc9870.jpg";